<template>
  <h3 class="txt-center">
    <!-- {{ $t('uiKit.beamsEdition.beamsCount') }} -->
    {{ translate('pb2.beamsGridSize.gridSizeTitle') }}
  </h3>

  <div class="pb-beams-actions">
    <ControlCounter
      v-model="constrainedColumns"
      class="pb-beams-action-grid-size-item"
      :disabled="disabled"
      :editable="!disabled"
      :min="minAllowedColumns"
      :max="maxAllowedColumns"
    />
    <div class="txt-muted pb-beams-action-grid-size-item">
      <i class="icon-remove" />
    </div>
    <ControlCounter
      v-model="constrainedRows"
      class="pb-beams-action-grid-size-item"
      :disabled="disabled"
      :editable="!disabled"
      :min="minAllowedRows"
      :max="maxAllowedRows"
    />
  </div>
</template>

<script setup lang="ts">
import ControlCounter from '@nicolaudie-group/ng-ui-kit/components/ControlCounter/ControlCounter.vue'
import { computed } from 'vue'

import useTranslate from '@/composables/useTranslate'

interface Props {
  columns?: number,
  rows?: number,
  minAllowedColumns?: number,
  maxAllowedColumns?: number,
  minAllowedRows?: number,
  maxAllowedRows?: number,
  disabled?: boolean,
}

defineOptions({
  compatConfig: {
    // MODE: 3, // opt-in to Vue 3 behavior for this component only
  },
})

const props = withDefaults(defineProps<Props>(), {
  columns: 0,
  rows: 0,
  minAllowedColumns: 0,
  maxAllowedColumns: 0,
  minAllowedRows: 0,
  maxAllowedRows: 0,
  disabled: false,
})

const emit = defineEmits<{
  gridSizeChanged: [columns: number, rows: number],
}>()

const { translate } = useTranslate()

const gridSizeChanged = (columns: number, rows: number) => {
  emit('gridSizeChanged', columns, rows)
}

const setColumns = (columns: number) => {
  gridSizeChanged(columns, props.rows)
}

const setRows = (rows: number) => {
  gridSizeChanged(props.columns, rows)
}

const constrainedColumns = computed({
  get() { return props.columns },
  set(columns) { setColumns(columns) },
})

const constrainedRows = computed({
  get() { return props.rows },
  set(rows) { setRows(rows) },
})

</script>

<style lang="scss" src="./BeamsGridSize.scss" />
